import React from 'react';
import clsx from 'clsx';
import { AlertTriangle } from 'lucide-react';
import Tooltip from '@components/common/Tooltip';
import styles from './StatusCell.module.css';

export interface StatusCellProps {
  children: React.ReactNode;
  hasConflict?: boolean;
  conflictTooltip?: string;
  className?: string;
}

const StatusCell: React.FC<StatusCellProps> = ({ children, hasConflict, conflictTooltip, className }) => {
  return (
    <div className={clsx(styles.statusCellWrapper, className)}>
      {children}
      {hasConflict && conflictTooltip && (
        <Tooltip content={conflictTooltip} position="top" variant="error">
          <span className={styles.conflictWarningIcon} data-test-id="conflict-warning-icon">
            <AlertTriangle size={16} />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default StatusCell;
